import React, { useEffect, useState, forwardRef } from 'react';

const FloatingInput = forwardRef(({
  fieldName,
  wrapperClass = '',
  label,
  hideLabel = false,
  allowNull = true,
  inputType = 'text',
  value = '',
  step,
  errors = [],
  helpText = '',
  parent = '',
  autofocus = false,
  disabled = false,
  width = '',
  style = {},
  many = false,
  onChange = () =>  {},
  pk = null
}, ref) => {
  const [inputValue, setInputValue] = useState(value);
  const localOnChange = (e) => {
    setInputValue(e.target.value)
    onChange({'name':fieldName, 'type': 'change', 'value': e.target.value, 'label': e.target.value})
  }
  const onBlur = (e) => {
    onChange({'name':fieldName, 'type': 'blur', 'value': e.target.value, 'label': e.target.value})
  }
  useEffect(() => {
    setInputValue(value)
  }, [value])
  return <>
      <input
        ref={ref}
        id={pk ? pk + '_' + fieldName : fieldName}
        name={fieldName}
        className={`form-control ${style.class} ${errors.length > 0 ? 'is-invalid' : ''}`}
        type={inputType}
        placeholder={style.placeholder}
        value={inputValue}
        step={step}
        data-char_select_parent={parent}
        autoFocus={autofocus && inputType !== 'hidden'}
        disabled={disabled}
        onBlur={onBlur}
        onChange={localOnChange}
      />
    </>
});

export default FloatingInput;